import { ASSET_PREFIX, colors } from 'utils/constants';

const BoostedBadge = ({ colour = 'pink' }: { colour?: string }) => {
  let backgroundColour;
  switch (colour) {
    case 'grey':
      backgroundColour = colors.primaryBrandGray;
      break;

    case 'pink':
    default:
      backgroundColour = '#FF399E';
  }

  return (
    <div className="boostedBadge flexCentered flexRow">
      <>
        <img
          src={`${ASSET_PREFIX}/images/prizes/white-rocket-boost-icon.png`}
          alt=""
        />
        Boosted
      </>

      <style jsx>
        {`
          .boostedBadge {
            background: ${backgroundColour};
            border-radius: 30px;
            color: white;
            font-size: 0.75em;
            font-weight: 700;
            padding: 0.9em 1.1em;
            text-transform: uppercase;
            margin-left: 1.25em;
          }

          .boostedBadge img {
            width: 13px;
            margin-right: 0.5em;
          }
        `}
      </style>
    </div>
  );
};

export default BoostedBadge;
